import Vue from 'vue'
import {
  decode,
  getBreakpoint
} from 'utils/general'

/**
 * Product card slider component
 */
Vue.component('product-card-slider', resolve => {
  Promise.all([
    enqueueModule('product-card.vue'),
    enqueueModule('vue-flickity.vue')
  ]).then(() => resolve({
    props: ['products', 'showDots'],
    data () {
      return {
        flickityOptions: {
          prevNextButtons: false,
          pageDots: this.showDots || false,
          cellAlign: 'left',
          freeScroll: false,
          wrapAround: false,
          contain: true,
          groupCells: true
        },
        viewportSize: ''
      }
    },
    created () {
      window.addEventListener('resize', this.resizeHandler)
    },
    destroyed () {
      window.removeEventListener('resize', this.resizeHandler)
    },
    computed: {
      productsDecoded () {
        return typeof this.products === 'string' ? JSON.parse(decode(this.products)) : this.products
      },
      isCarousel () {
        switch (this.viewportSize) {
          case 'xxs':
            return this.productsDecoded.length > 1
          case 'xs':
            return this.productsDecoded.length > 2
          case 's':
            return this.productsDecoded.length > 3
          case 'm':
            return this.productsDecoded.length > 4
          default:
            return this.productsDecoded.length > 4
        }
      }
    },
    methods: {
      resizeHandler () {
        this.viewportSize = getBreakpoint()
      }
    },
    mounted () {
      this.resizeHandler()
    },
    updated: function () {
      this.$nextTick(function () {
        if (typeof _swat !== 'undefined') {
          _swat.initializeActionButtons('.post__product')
        }
      })
    }
  }))
})
